import { render, staticRenderFns } from "./UploadScorm.vue?vue&type=template&id=3998091e&"
import script from "./UploadScorm.vue?vue&type=script&lang=js&"
export * from "./UploadScorm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports